import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/components/navigation.css';

function Navigation() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);

    const toggleMenu = (event) => {
        event.stopPropagation();
        setIsMenuOpen(!isMenuOpen);
    };

    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setIsMenuOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div ref={menuRef}>
            <button className='bouton' onClick={toggleMenu}>
                <h1>Menu</h1>
            </button>
            {isMenuOpen && (
                <ul style={{ border: '1px solid #ccc', padding: '10px', position: 'absolute', backgroundColor: '#fff' }}>
                    {/* <li>
                        <NavLink to="/">
                            <p className='navigation_ul_li'>Accueil</p>
                        </NavLink></li> */}
                    <li>
                        <NavLink to="/arroweb">
                            <p className="navigation_ul_li">ArroWeb Développement</p>
                        </NavLink></li>
                    <li>
                        <NavLink to="/realisations">
                            <p className="navigation_ul_li">Mes réalisations</p>
                        </NavLink></li>
                    <li>
                        <NavLink to="/tarifs">
                            <p className="navigation_ul_li">Tarifs</p>
                        </NavLink></li>
                    <li>
                        <NavLink to="/contact">
                            <p className="navigation_ul_li">Contact</p>
                        </NavLink>
                    </li>
                </ul>
            )}
        </div>
    );
}

export default Navigation;